import React, { useMemo } from 'react';
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { STAGE_ORDER, stageLabel } from './waStageLabels';

export default function WaFunnelChart({ funnel, title = 'Live pipeline' }) {
  const data = useMemo(() => {
    const f = funnel || {};
    return STAGE_ORDER.filter((s) => f[s] != null).map((s) => ({
      stage: stageLabel(s),
      key: s,
      count: f[s] || 0,
    }));
  }, [funnel]);

  if (!data.length) {
    return (
      <div className="bg-white border rounded-xl p-4 h-64 flex items-center justify-center text-gray-500 text-sm">
        No funnel data
      </div>
    );
  }

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm">
      <h2 className="font-semibold text-[#1B375B] mb-3">{title}</h2>
      <ResponsiveContainer width="100%" height={240}>
        <BarChart data={data} layout="vertical" margin={{ left: 8, right: 16 }}>
          <XAxis type="number" allowDecimals={false} />
          <YAxis type="category" dataKey="stage" width={120} tick={{ fontSize: 11 }} />
          <Tooltip />
          <Bar dataKey="count" fill="#659A9B" radius={[0, 4, 4, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
